var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable camelcase */
import { parseISO, format } from 'date-fns';
import { defaultColors } from '@hn-ui/themes';
import { escapeSpecialSymbols } from '../dashboards/yearly/useApi';
import '../String.Ext';
import { minsToHours } from './utils';
var isAuthStatus = function (status) {
    var isAuth = status === 401 || status === 403;
    return isAuth;
};
var getActivationReportRelativeUrl = function (monolithApiHost, schoolId, groupId, period, role) {
    return monolithApiHost + "/api/teachers/groups/" + groupId + "/activity_stream_report?activity_stream_filter=" + period + "&school_id=" + schoolId + "&role=" + role;
};
var parseGroupData = function (group) {
    var title = '';
    var summary = '';
    var _a = minsToHours(group.timeSpent), mins = _a.mins, hours = _a.hours;
    var hoursText = hours ? " " + hours + " h" : '';
    var minsText = '';
    if (mins)
        minsText = " " + mins + " min";
    else
        minsText = hours ? '' : ' < 1 min';
    title = group.title;
    summary = group.activeStudents + " active " + 'student'.pluralize(group.activeStudents) + ", " + group.tasksCompleted + " " + 'task'.pluralize(group.tasksCompleted) + " solved," + hoursText + minsText + " spent";
    return { title: title, summary: summary };
};
var transformActivityStreamData = function (_a) {
    var reports = _a.report;
    var groups = reports.map(function (report) {
        var _a = parseGroupData(report), title = _a.title, summary = _a.summary;
        var updatedStudents = report.students.map(function (student) {
            var normalizedStudentName = escapeSpecialSymbols(student.name);
            return __assign(__assign({}, student), { exercisesPercent: student.exercisesCompleted === 0
                    ? 0
                    : Math.round((student.exercisesCompletedSucc * 100) /
                        student.exercisesCompleted), exercisesCompletedSuccessfully: student.exercisesCompletedSucc, name: normalizedStudentName });
        });
        var group = {
            title: title,
            summary: summary,
            students: updatedStudents,
            startDate: report.startDate,
            endDate: report.endDate,
        };
        return group;
    });
    return { groups: groups };
};
export var fetchActivityStreamData = function (_a) {
    var schoolId = _a.schoolId, groupId = _a.groupId, _b = _a.period, period = _b === void 0 ? 'weekly' : _b, _c = _a.role, role = _c === void 0 ? 'teacher' : _c;
    return __awaiter(void 0, void 0, void 0, function () {
        var monolithApiHost, activationReportUrl, response, reportData, transformedReportData, result;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    monolithApiHost = process.env.HN_API_URL || '';
                    activationReportUrl = getActivationReportRelativeUrl(monolithApiHost, schoolId, groupId, period, role);
                    return [4 /*yield*/, fetch(activationReportUrl, {
                            headers: {
                                'Content-type': 'application/json;charset=UTF-8',
                            },
                        })];
                case 1:
                    response = _d.sent();
                    if (!response.ok) {
                        return [2 /*return*/, !isAuthStatus(response.status)
                                ? Promise.reject(Error("Unable to fetch report data: " + response.status + " " + response.statusText))
                                : undefined];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    reportData = _d.sent();
                    transformedReportData = transformActivityStreamData(reportData);
                    result = {
                        groups: transformedReportData.groups,
                    };
                    return [2 /*return*/, result];
            }
        });
    });
};
var getStudentActivationReportRelativeUrl = function (monolithApiHost, studentId, startDate, endDate) {
    return monolithApiHost + "/api/teachers/students/" + studentId + "/activity_stream?date=" + startDate + "&end_date=" + endDate;
};
var parseStudentGroupData = function (group) {
    var title = '';
    var summary = '';
    var seenSummary = '';
    var _a = minsToHours(group.timeSpent), mins = _a.mins, hours = _a.hours;
    var hoursText = hours ? " " + hours + " h" : '';
    var minsText = '';
    if (mins)
        minsText = " " + mins + " min";
    else
        minsText = hours ? '' : ' < 1 min';
    var isAllSeen = group.seenNotifications.length === group.struggleTasks;
    var struggleCount = isAllSeen
        ? group.struggleTasks
        : group.struggleTasks - group.seenNotifications.length;
    var struggleColor = isAllSeen ? '#777B8B' : defaultColors.red50;
    var struggle = group.struggleTasks
        ? " <span style='color: " + struggleColor + ";'>(" + struggleCount + " struggle " + 'task'.pluralize(struggleCount) + ")</span>"
        : '';
    title = group.title;
    summary = group.tasksCompleted + " " + 'task'.pluralize(group.tasksCompleted) + " solved" + struggle + " | time spent:" + hoursText + minsText + " | avg. accuracy " + group.avgAccuracy + "%";
    if (!isAllSeen && group.struggleTasks) {
        var seenStruggle = " <span style='color:#777B8B;'>(" + group.struggleTasks + " struggle " + 'task'.pluralize(group.struggleTasks) + ")</span>";
        seenSummary = group.tasksCompleted + " " + 'task'.pluralize(group.tasksCompleted) + " solved" + seenStruggle + " | time spent:" + hoursText + minsText + " | avg. accuracy " + group.avgAccuracy + "%";
    }
    else
        seenSummary = summary;
    return { title: title, summary: summary, seenSummary: seenSummary };
};
var transformStudentActivityStreamData = function (data) {
    var output = data.map(function (d) {
        var activeStruggleCards = [];
        var _a = parseStudentGroupData(d), title = _a.title, summary = _a.summary, seenSummary = _a.seenSummary;
        var cards = d.cards.map(function (c) {
            return ({
                id: c.cardId,
                sessionId: c.sessionId,
                link: c.cardLink,
                accuracy: c.accuracy,
                prefix: c.cardLetter,
                timeSpent: c.timeSpent,
                title: c.cardName,
                struggle: c.struggle,
                status: c.completed ? 'completed' : 'progress',
                date: format(parseISO(c.date), 'MMM dd'),
                exerciseFinished: c.exerciseFinished,
                exerciseFinishedSucc: c.exerciseFinishedSucc,
            });
        });
        var deletedCards = d.deletedCards && {
            accuracy: d.deletedCards.accuracy,
            cardsCount: d.deletedCards.cardsCount,
            exerciseFinished: d.deletedCards.exerciseFinished,
            exerciseFinishedSucc: d.deletedCards.exerciseFinishedSucc,
            timeSpent: d.deletedCards.timeSpent,
        };
        cards.forEach(function (card) {
            if (card.struggle && !d.seenNotifications.includes(card.sessionId))
                activeStruggleCards.push(card.sessionId);
        });
        return {
            title: title,
            summary: summary,
            seenSummary: seenSummary,
            cards: cards,
            activeStruggleCards: activeStruggleCards,
            deletedCards: deletedCards,
        };
    });
    return output;
};
export var fetchStudentActivityStreamData = function (_a) {
    var studentId = _a.studentId, startDate = _a.startDate, endDate = _a.endDate;
    return __awaiter(void 0, void 0, void 0, function () {
        var monolithApiHost, activationReportUrl, response, reportData, transformedReportData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    monolithApiHost = process.env.HN_API_URL || '';
                    activationReportUrl = getStudentActivationReportRelativeUrl(monolithApiHost, studentId, startDate, endDate);
                    return [4 /*yield*/, fetch(activationReportUrl, {
                            headers: {
                                'Content-type': 'application/json;charset=UTF-8',
                            },
                        })];
                case 1:
                    response = _b.sent();
                    if (!response.ok) {
                        return [2 /*return*/, !isAuthStatus(response.status)
                                ? Promise.reject(Error("Unable to fetch report data: " + response.status + " " + response.statusText))
                                : undefined];
                    }
                    return [4 /*yield*/, response.json()];
                case 2:
                    reportData = _b.sent();
                    transformedReportData = transformStudentActivityStreamData(reportData);
                    return [2 /*return*/, transformedReportData];
            }
        });
    });
};
export var downloadReport = function (url, reportName) { return __awaiter(void 0, void 0, void 0, function () {
    var response, finalReportName, attachmentHeader, content;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    headers: {
                        'Content-Type': 'application/pdf',
                    },
                })];
            case 1:
                response = _a.sent();
                finalReportName = reportName || 'report.pdf';
                attachmentHeader = (response.headers.get('Content-disposition') || '').split("utf-8''");
                if (attachmentHeader.length > 0)
                    finalReportName = decodeURIComponent(attachmentHeader[1]);
                return [4 /*yield*/, response.blob()];
            case 2:
                content = _a.sent();
                return [2 /*return*/, { content: content, reportName: finalReportName }];
        }
    });
}); };
export var markCardsAsSeen = function (_a) {
    var studentId = _a.studentId, activeStruggleCards = _a.activeStruggleCards;
    if (activeStruggleCards.length !== 0) {
        var tokenNode = document.querySelector('meta[name="csrf-token"]');
        var csrfToken = (tokenNode === null || tokenNode === void 0 ? void 0 : tokenNode.getAttribute('content')) || '';
        fetch("/api/teachers/students/" + studentId + "/mark_seen", {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                session_ids: activeStruggleCards,
                authenticity_token: csrfToken,
            }),
        });
    }
};
